<div class="hotel-card" [ngClass]="policyClass">
  @if (policyLabel) {
    <span class="visuallyhidden">{{ policyLabel }}</span>
  }
  <div class="hotel-card__body">
    <div class="hotel-card__info">
      @if (card.distance != null) {
        <div class="hotel-card__row">
          <fa-icon [icon]="faLocationDot"></fa-icon>
          <span>{{ card.distance | number: '1.1-1' }} {{ card.distanceUnit || 'mi' }}</span>
        </div>
      }
      <button class="hotel-card__name-link" (click)="navigateToHotel($event)">
        {{ card.name }}
      </button>
      @if (card.address) {
        <div class="hotel-card__row">
          <fa-icon [icon]="faLocationDot"></fa-icon>
          <span>{{ card.address }}</span>
        </div>
      }
      @if (card.dateRange) {
        <div class="hotel-card__row">
          <fa-icon [icon]="faCalendarDays"></fa-icon>
          <span>{{ card.dateRange }}</span>
        </div>
      }
    </div>
    <div class="hotel-card__price-col">
      <button
        type="button"
        class="hotel-card__expand-toggle"
        [attr.aria-expanded]="isExpanded"
        [attr.aria-label]="('Select' | translate) + ' ' + card.name"
        (click)="toggleExpand()"
      >
        <span class="hotel-card__price-group">
          <span class="hotel-card__price-label">{{ 'From' | translate }}</span>
          @if (card.price) {
            <span class="hotel-card__price-amount">{{ formattedPrice }}</span>
          }
        </span>
        <fa-icon
          [icon]="isExpanded ? faChevronUp : faChevronDown"
          class="hotel-card__chevron"
        ></fa-icon>
      </button>
      <!-- Policy indicator: same component/tooltip as the results page,
           placed under the headline room per the travel-policy spec. -->
      <app-warning-tags
        [ticket]="headlineWarningTicket"
        [displayCheck]="false"
        (click)="$event.stopPropagation()"
      ></app-warning-tags>
    </div>
  </div>

  <!-- Room list, shown on expand. The printed number is the one the assistant uses,
       so "room 2" means the same room to the traveller and to the bot. Tracked by
       roomIndex, not roomId: two rooms at the same rate share a roomId, and
       duplicate track keys throw at render. -->
  @if (isExpanded && card.rooms?.length) {
    <div class="hotel-card__rooms">
      @for (room of displayedRooms; track room.roomIndex) {
        <div class="hotel-card__room">
          <span class="hotel-card__room-desc">{{ room.roomIndex }}. {{ room.description }}</span>
          <app-warning-tags
            [ticket]="warningTicketFor(room)"
            [displayCheck]="false"
            (click)="$event.stopPropagation()"
          ></app-warning-tags>
          <button
            class="hotel-card__booking-conditions"
            (click)="openBookingConditions(room, $event)"
            i18n="@@chatHotelBookingConditions"
          >
            Booking Conditions
          </button>
          <button
            type="button"
            class="hotel-card__room-price hotel-card__room-price--link"
            [disabled]="room.unavailable"
            [attr.aria-disabled]="room.unavailable ? true : null"
            [attr.aria-label]="
              ('Select' | translate) + ' room ' + room.roomIndex + ', ' + room.description
            "
            (click)="onSelectRoom(room, $event)"
          >
            {{ formatRoomPrice(room) }}
          </button>
        </div>
      }
      @if (!showAllRates && hiddenRoomsCount > 0) {
        <button class="hotel-card__see-all-rates" (click)="showAllRates = true">
          {{ 'See All' | translate }} {{ card.rooms!.length }} {{ 'Rates' | translate }}
        </button>
      }
    </div>
  }

  <app-chat-card-feedback
    class="hotel-card__feedback"
    [feedbackId]="feedbackId"
    [summary]="feedbackSummary"
  ></app-chat-card-feedback>
</div>
